module.exports = __webpack_public_path__ + "img/64145334fb27a54d9700202a7298f18d.bb078150.png";